/*@flow*/
import type { Node } from 'react';
import React, { useContext } from 'react';
import { StackContext } from './contexts';
import Panel from './Panel';

const is = (name) => (v) => v.type === name;
const filter = (pred) => (v) => v.filter(pred);
const getOwn = filter(is('gradient'));

export type GradientT = {
  colorRange: string[],
  type: string,
  title: string,
  uuid: string,
  category_type: string,
};

// Gradient Panels
// -------------------
//
// {
//   type: 'gradient',
//   title: 'Foo',
//   colorRange: ['#C0FFEE'],
// }

const Component = ({
  setInternalUpdate,
  internalUpdate,
}: {
  internalUpdate: any,
  setInternalUpdate: Function,
}): null | Array<Node> | Array<any> => {
  const legends = useContext(StackContext);
  const ownLegends = getOwn(legends);
  if (ownLegends.isEmpty()) return null;
  let ol = ownLegends.toJS();
  if (!Array.isArray(ol)) return ([]: any[]);
  ol = ((ol: any): GradientT[]);
  return ol.map<*, *>((v, k) => (
    <Panel
      title={v.title}
      type="gradient"
      gradient={v.colorRange}
      key={k}
      historyFilters={{}}
      category_type={v.category_type}
      uuid={v.uuid}
      setInternalUpdate={setInternalUpdate}
      internalUpdate={internalUpdate}
    />
  ));
};

export default Component;
